(function ($) {
    jQuery(document).ready(function () {
        if (jQuery('.meteo-bloc').length) {
            meteo();
        }

        function applyWeather(data) {
            jQuery('.meteo-bloc .temperature').html(parseInt(data.main.temp) + '°C');
            jQuery('.meteo-bloc .temperature_feel').html(parseInt(data.main.feels_like) + '°C');
            if (data.wind.deg && data.wind.speed) {
                jQuery('.meteo-bloc .wind .speed').html(getWindDirection(data.wind.deg.toFixed(1)) + ' ' + data.wind.speed.toFixed(1));
            }
            jQuery('.meteo-bloc .rain .percent').html(data.pop || '0');

            var icon = data.weather[0].icon;
            jQuery('.meteo-bloc .weather .icon').attr('src', 'https://openweathermap.org/img/wn/' + icon + '@2x.png');
            var toAddClass = jQuery('.meteo-bloc .weather,.meteo-bloc .weather .icon').addClass(data.weather[0].description.toLowerCase().replace(/clear/g, '')).addClass(icon);
            if (typeof (data.weather[1]) !== 'undefined') {
                toAddClass.addClass(data.weather[1].description.toLowerCase().replace(/clear/g, ''));
            }
        }

        function meteo() {
            var meteoCookie = jQuery.cookie('meteo');
            if (meteoCookie != undefined) {
                var data = jQuery.parseJSON(meteoCookie);
                applyWeather(data);
            } else {
                jQuery.ajax({
                    url: 'https://api.openweathermap.org/data/2.5/weather?q=hampstead,CA&units=metric&lang=fr_CA&APPID=8610d789d0397ab09f4265f09bb9552a&callback=?',
                    dataType: 'jsonp',
                    type: 'GET',
                    data: {},
                    success: function (data) {
                        var date = new Date();
                        var m = 15;
                        date.setTime(date.getTime() + (m * 60 * 1000));
                        jQuery.cookie('meteo', JSON.stringify(data), {expires: date, path: '/'});
                        applyWeather(data);
                    },
                    beforeSend: function () {
                        //jQuery('.meteo-bloc .weather').addClass('loading');
                    },
                    complete: function () {
                        //jQuery('.meteo-bloc .weather').removeClass('loading');
                    }
                });
            }
        }

        function getWindDirection(direction) {
            var lang = jQuery('html').attr('lang');
            var directionName = '';
            if (direction >= 0) {
                directionName = (lang == 'all') ? 'N' : 'N';
            }
            if (direction >= 22.5) {
                directionName = (lang == 'all') ? 'N/NE' : 'N/NE';
            }
            if (direction >= 45) {
                directionName = (lang == 'all') ? 'N/E' : 'N/E';
            }
            if (direction >= 67.5) {
                directionName = (lang == 'all') ? 'E/NE' : 'E/NE';
            }
            if (direction >= 90) {
                directionName = (lang == 'all') ? 'E' : 'E';
            }
            if (direction >= 112.5) {
                directionName = (lang == 'all') ? 'E/SE' : 'E/SE';
            }
            if (direction >= 135) {
                directionName = (lang == 'all') ? 'S/E' : 'S/E';
            }
            if (direction >= 157.5) {
                directionName = (lang == 'all') ? 'S/SE' : 'S/SE';
            }
            if (direction >= 180) {
                directionName = (lang == 'all') ? 'S' : 'S';
            }
            if (direction >= 202.5) {
                directionName = (lang == 'all') ? 'S/SO' : 'S/SW';
            }
            if (direction >= 225) {
                directionName = (lang == 'all') ? 'S/O' : 'S/W';
            }
            if (direction >= 247.5) {
                directionName = (lang == 'all') ? 'O/SO' : 'W/SW';
            }
            if (direction >= 270) {
                directionName = (lang == 'all') ? 'O' : 'W';
            }
            if (direction >= 292.5) {
                directionName = (lang == 'all') ? 'O/NO' : 'W/NW';
            }
            if (direction >= 315) {
                directionName = (lang == 'all') ? 'N/O' : 'N/W';
            }
            if (direction >= 337.5) {
                directionName = (lang == 'all') ? 'N/NO' : 'N/NW';
            }

            return directionName;
        }
    });
})(jQuery);
